// components/BookingModal/TextInput.js
import React from 'react';
import styles from './styles.module.scss';

const TextInput = ({
  label,
  name,
  value,
  onChange,
  type = 'text',
  required = false,
  disabled = false,
  placeholder = '',
  error = '',
  rows = 4,
  className = '',
  ...props
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const inputClass = `${styles.input} ${error ? styles.error : ''} ${disabled ? styles.disabled : ''} ${className}`;
  const labelClass = `${styles.label} ${required ? styles.required : ''}`;

  return (
    <div className={styles.inputContainer}>
      {label && (
        <label htmlFor={name} className={labelClass}>
          {label}
          {required && <span className={styles.requiredAsterisk}>*</span>}
        </label>
      )}
      
      {type === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          placeholder={placeholder}
          className={`${inputClass} ${styles.textarea}`}
          rows={rows}
          {...props}
        />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          placeholder={placeholder}
          className={inputClass}
          {...props}
        />
      )}
      
      {error && (
        <div className={styles.errorMessage}>
          {error}
        </div>
      )}
    </div>
  );
};

export default TextInput;